import * as types from '../mutation-types';
import {Form} from 'vform';
import axios from 'axios';

const state = {
    mini: false,
    drawer: true,
};

const getters = {
    mini: state => state.mini,
    drawer: state => state.drawer
};

const mutations = {
    [types.LAYOUT_MINI](state) {
        state.mini = !state.mini;
    },
    [types.LAYOUT_DRAWER](state) {
        state.drawer = !state.drawer;
    },
}

export {
    getters,
    mutations,
    state,
}
